export const environment = {
  apiGoogleMapsKey: 'AIzaSyD27A5PPYpZVDH2JKiM-yozH8bRK_f6HII',
  aemetKey:
    'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhbmdlbGJ5cm9uLjE4QGFnZW5jaWFtb2NhLmNvbSIsImp0aSI6ImE5MTRiYTdhLWQzMTYtNGFhZC04MzMzLWIzN2VmZDhjZGRiNCIsImlzcyI6IkFFTUVUIiwiaWF0IjoxNzQ4OTQzMTEwLCJ1c2VySWQiOiJhOTE0YmE3YS1kMzE2LTRhYWQtODMzMy1iMzdlZmQ4Y2RkYjQiLCJyb2xlIjoiIn0.XAAAd4u50Xgah3MHNCvaeR0WQSt7-mk7yTEQlzuc9qk',
  apiUrl: 'https://dev.cacerestrujillo.vrestudio.com/api/v1/public',
  analytics: {
    enabled: false,
    gtmContainerId: 'GTM-PGG56HT9',
  },
  zone_id: 1,
  project_name: 'Cáceres y Trujillo',
};
